import { Dropdown } from '@innovamat/glimmer-components';
import { useTranslation } from 'react-i18next';
import { useAddActionDropdown } from '../../../hooks/use-add-action-dropdown';
import { useClassroomCapabilities } from '../../../hooks/use-classroom-capabilities';
import { useOrganization } from '../../../hooks/use-organization';
import { Classroom } from '../../../modules/classroom';

type Props = {
  isDeletedStudentsPage: boolean;
  isDisabled?: boolean;
  classroom?: Classroom;
};

function AddStudentDropdown({
  classroom,
  isDeletedStudentsPage,
  isDisabled,
}: Props): JSX.Element | null {
  const { t } = useTranslation();
  const { isOrgAnonymized, isRosteringEnabled } = useOrganization();
  const {
    students: { canDemoBeAdded },
  } = useClassroomCapabilities({
    classroom,
  });
  const { getOptions } = useAddActionDropdown({
    type: 'schoolStudent',
    onAddDemoStudent: canDemoBeAdded ? () => {} : undefined,
  });

  if (isRosteringEnabled) {
    return null;
  }

  if (!isDeletedStudentsPage && !isOrgAnonymized)
    return (
      <Dropdown openOnHover={true} disabled={isDisabled}>
        <Dropdown.Toggle label={t('students.button.addStudent')} />
        <Dropdown.Content position={'bottomRight'}>
          {getOptions().map((option) => (
            <Dropdown.Item {...option} />
          ))}
        </Dropdown.Content>
      </Dropdown>
    );

  return <></>;
}

export { AddStudentDropdown };
